import { useEffect } from 'react';

export function useParallax(intensity = 1) {
  useEffect(() => {
    if (intensity <= 0) return;
    const els = document.querySelectorAll("[data-parallax]");
    let raf = 0;
    
    const update = () => {
      const vh = window.innerHeight;
      els.forEach(el => {
        const speed = parseFloat(el.dataset.parallax || "0.2") * intensity;
        const rect = el.getBoundingClientRect();
        const center = rect.top + rect.height / 2 - vh / 2;
        const t = -center * speed;
        el.style.transform = `translate3d(0, ${t.toFixed(2)}px, 0)`;
      });
      raf = 0;
    };
    
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };
    
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
      els.forEach(el => el.style.transform = "");
    };
  }, [intensity]);
}
